import cx from "classnames";
import { filter, find, get } from "lodash";
import {
  MDBAnimation,
  MDBCollapse,
  MDBContainer,
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBListGroup,
  MDBListGroupItem,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBNavItem,
  MDBNavLink
} from "mdbreact";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Chat from "~/assets/img/desktop/logo/chat.svg";
import { partnerInfo } from "~/configs/partnerDetails";
import { VERSION_DATE, VERSION_WEB } from "~/configs/version";
import { redirectToMedproId } from "~/store/login/actions";
import { checkReadNoti } from "~/store/notifications/notificationsActions";
import {
  getPatientList,
  selectPatientFromList
} from "~/store/patient/patientAction";
import { selectMedicalBill } from "~/store/totalData/actions";
import { logOut } from "~/store/user/userAction";
import { getDurationFromNowTo, getNextStepViewNoti } from "~/utils/func";
import { urlLogoHeader } from "~/utils/manageResource";
import partnerId from "~/utils/partner";
import styles from "./style.module.scss";

class Header extends Component {
  state = {
    collapseID: ""
  };

  notiBell = React.createRef();
  userButton = React.createRef();

  toggleCollapse = collapseID => () =>
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ""
    }));

  renderSomeNotifications = () => {
    const limit = 3;
    const {
      notification: { data }
    } = this.props;

    if (!data) {
      return <div />;
    }

    // Wait update API noti

    const finData = filter(data, { isRead: false });

    let handleData;
    if (finData.length < 1) {
      handleData = data;
    } else {
      handleData = finData;
    }

    return handleData.slice(0, limit).map((noti, i) => {
      const titleNoti = noti.hospital ? noti.hospital.name : "";

      return (
        <MDBListGroupItem
          key={i}
          className={!noti.isRead ? styles.new : null}
          onClick={() => this.handleViewDetailNoti(noti)}
        >
          <div className={styles.list_news_head}>{titleNoti}</div>
          <p>{noti.title}</p>
          <p>
            <i className="fal fa-clock" />
            {getDurationFromNowTo(noti.createdAt)}
          </p>
        </MDBListGroupItem>
      );
    });
  };

  handleViewDetailNoti = noti => {
    const { history } = this.props;
    this.props.checkReadNoti(noti.id);
    const partnerId = get(noti, "eventData.partnerId", "");
    this.props.selectMedicalBill(partnerId, null);
    const typePaymentNoti = get(noti, "topicId", null);

    if (typePaymentNoti === "exam.result") {
      const patientId = get(noti, "eventData.patientId", null);
      this.props.selectPatientFromList(patientId);
    }

    const url = getNextStepViewNoti(noti);

    if (typePaymentNoti === "bookings.confirm") {
      history.push(url);
    } else if (typePaymentNoti === "invoice.confirm") {
      window.open(url, "_blank") || window.location.replace(url);
    } else {
      history.push(url);
    }
  };

  getActiveClass = pathname => {
    return this.props.location.pathname === pathname
      ? styles.active + " " + styles["active_" + partnerId]
      : styles["itemMenu_" + partnerId];
  };

  componentDidMount() {
    // this.props.getPatientList();
  }

  render() {
    const { IsAuthenticated, logOut, infoUser, notification } = this.props;
    const checkUrlClinic = window.location.href.indexOf("/clinic");
    const fullName = get(infoUser, "fullName");
    const userName = get(infoUser, "userName");
    const displayName = fullName !== "" ? fullName : userName;

    const info = get(partnerInfo, "info", "");
    const name = find(info, { key: "name" });

    const menu = get(partnerInfo, "menu");
    const renderMenu = menu.map((item, index) => {
      return (
        <MDBNavItem className={cx(this.getActiveClass(item.url))} key={index}>
          <MDBNavLink
            className=""
            to={item.link}
            replace={this.props.location.pathname === item.link}
          >
            {item.name}
          </MDBNavLink>
        </MDBNavItem>
      );
    });

    const cls = cx({
      [styles.logoDefault]: true
    });

    const img_Support = () => {
      switch (partnerId) {
        default:
          return Chat;
      }
    };

    return (
      <MDBContainer
        fluid
        className={cx(styles.MenuTop, styles["MenuTop" + partnerId])}
      >
        <MDBAnimation
          type="fadeIn"
          className={cx(
            styles.header,
            styles.header_classic,
            styles.header_shadow,
            styles["header_" + partnerId],
            "d-none d-lg-block"
          )}
        >
          <div
            className={
              partnerId === "medpro"
                ? styles.header_content
                : styles.header_content_normal
            }
          >
            <div
              className={partnerId === "medpro" ? null : styles.header_brand}
            >
              <a href="/cham-soc-khach-hang">
                <img src={urlLogoHeader} alt={name.value} className={cls} />
              </a>
            </div>
            <nav
              className={
                partnerId === "medpro"
                  ? cx(styles.navigator, styles.navigator_special)
                  : styles.navigator
              }
            >
              <div
                className={checkUrlClinic > -1 ? styles.view : styles.nav_info}
              >
                <div className={styles.widget} />
                <MDBListGroup
                  className={
                    checkUrlClinic > -1
                      ? styles.hidden
                      : styles.list_group_dangnhap
                  }
                >
                  {IsAuthenticated ? (
                    <MDBListGroupItem>
                      <MDBDropdown className={styles.mdbropdown}>
                        <MDBDropdownToggle
                          ref={this.notiBell}
                          className={cx(styles.button, styles.bell)}
                        >
                          <i className="fal fa-bell" />
                          {notification.totalNew ? (
                            <span className={styles.count}>
                              {notification.totalNew}
                            </span>
                          ) : null}
                        </MDBDropdownToggle>
                        <MDBDropdownMenu
                          onClick={() => this.notiBell.current.onClick()}
                          right
                          className={cx(
                            styles.mdbdropdownMenu,
                            styles.mdbdropdownBell
                          )}
                        >
                          <div className={styles.head_alert}>
                            <span>Danh sách thông báo</span>
                          </div>
                          <div className={styles.mdbdropdownItem}>
                            <MDBListGroup className={styles.list_news}>
                              {this.renderSomeNotifications()}
                              <MDBListGroupItem>
                                <Link
                                  to={{
                                    pathname: "/user",
                                    state: { activeItem: 3 }
                                  }}
                                  replace={
                                    this.props.location.pathname === "/user"
                                  }
                                  className={styles.view_all}
                                >
                                  <span>Xem tất cả </span>
                                </Link>
                              </MDBListGroupItem>
                            </MDBListGroup>
                          </div>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBListGroupItem>
                  ) : null}
                  <MDBListGroupItem>
                    <Link
                      to={{
                        pathname: "/",
                        state: { scrollToDownload: true }
                      }}
                      replace={this.props.location.pathname === "/"}
                      className={cx(
                        styles.button,
                        styles.downloadApp,
                        styles["downloadApp_" + partnerId]
                      )}
                    >
                      Tải ứng dụng
                    </Link>
                  </MDBListGroupItem>
                  {!IsAuthenticated ? (
                    <MDBListGroupItem>
                      <Link
                        to="#"
                        className={cx(
                          styles.button,
                          styles.login,
                          styles["login_" + partnerId]
                        )}
                        onClick={() => {
                          this.props.redirectToMedproId();
                        }}
                      >
                        Đăng nhập
                      </Link>
                    </MDBListGroupItem>
                  ) : (
                    <MDBListGroupItem>
                      <MDBDropdown className={styles.mdbropdown}>
                        <MDBDropdownToggle
                          className={cx(styles.button, styles.after_login)}
                          ref={this.userButton}
                        >
                          {displayName}
                        </MDBDropdownToggle>
                        <MDBDropdownMenu
                          onClick={() => this.userButton.current.onClick()}
                          right
                          basic
                          className={cx(
                            styles.mdbdropdownMenu,
                            styles.mdbdropdownProfile
                          )}
                        >
                          <MDBListGroup>
                            <MDBListGroupItem className={styles.item_user}>
                              <div className={styles.item_user_icon}>
                                <i className="fas fa-user-circle" />{" "}
                              </div>
                              <div className={styles.info}>
                                <span>Xin chào!</span>
                                <div className={styles.info_name}>
                                  <b>{displayName}</b>
                                </div>
                              </div>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 1 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-address-book" /> Hồ sơ bệnh
                                nhân{" "}
                              </Link>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 2 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-file-medical" /> Phiếu khám
                                bệnh
                              </Link>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <Link
                                to={{
                                  pathname: "/user",
                                  state: { activeItem: 3 }
                                }}
                                replace={this.props.location.pathname === "/"}
                              >
                                <i className="fal fa-bell" />
                                Thông báo
                              </Link>
                            </MDBListGroupItem>

                            <MDBListGroupItem className={styles.item_sign_out}>
                              <Link
                                onClick={() => {
                                  logOut();
                                  this.props.history.push("/");
                                }}
                                to="#"
                              >
                                <i className="fal fa-power-off" /> Thoát
                              </Link>
                            </MDBListGroupItem>
                            <MDBListGroupItem
                              className={styles.item_information}
                            >
                              <div className={styles.version}>
                                <i>Phiên bản {VERSION_WEB}</i>
                                <i>Mới nhất: {VERSION_DATE}</i>
                              </div>
                            </MDBListGroupItem>
                          </MDBListGroup>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBListGroupItem>
                  )}
                </MDBListGroup>
              </div>
              <div className={styles.menubar}>
                <MDBNavbar expand="lg" className={styles.mdbNavbar}>
                  <MDBNavbarToggler
                    className={styles.mdbNavbarToggler}
                    onClick={this.toggleCollapse("navbarCollapse3")}
                  >
                    <i className="fas fa-bars" />
                  </MDBNavbarToggler>
                  <MDBCollapse
                    className={styles.mdbCollapse}
                    id="navbarCollapse3"
                    isOpen={this.state.collapseID}
                    navbar
                  >
                    <MDBNavbarNav
                      className={cx(
                        styles.mdbNavbarNav,
                        styles["mdbNavbarNav_" + partnerId]
                      )}
                    >
                      {renderMenu}
                    </MDBNavbarNav>
                  </MDBCollapse>
                </MDBNavbar>
              </div>
            </nav>
            <div
              className={
                partnerId === "medpro"
                  ? cx(styles.menu_extra, styles.menu_medpro_custom)
                  : cx(styles.menu_extra, styles.menu_partner_custom)
              }
            >
              <div
                className={cx(
                  styles.header_info_text,
                  styles["header_info_text_" + partnerId]
                )}
              >
                <div className={cx(styles.icons_info, styles.widget)}>
                  <div className={styles.icons}>
                    <img src={img_Support()} alt="Support Medpro" />
                  </div>
                  <div className={styles.info_right}>
                    Bạn cần trợ giúp?
                    <br />
                    <a className={styles.dot} href="tel:1900-2115">
                      1900-2115
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MDBAnimation>
      </MDBContainer>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated, info: infoUser },
    notification,
    global
  } = state;
  return {
    global,
    IsAuthenticated,
    notification,
    infoUser
  };
};

export default connect(mapStateToProps, {
  getPatientList,
  redirectToMedproId,
  checkReadNoti,
  selectMedicalBill,
  selectPatientFromList,
  logOut
})(withRouter(Header));

// {partnerId === "medpro" && (
//   <MDBListGroupItem>
//     <Link
//       to={{
//         pathname: "/clinic"
//       }}
//       replace={this.props.location.pathname === "/"}
//       className={cx(styles.button, styles.clinic)}
//     >
//       Quản lý phòng mạch
//     </Link>
//   </MDBListGroupItem>
// )}
